import { render, staticRenderFns } from "./releasePopup.vue?vue&type=template&id=5b52e8f5&"
import script from "./releasePopup.vue?vue&type=script&lang=js&"
export * from "./releasePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports